import React from 'react'
import * as S from './InputStyle'

export interface iInput {
    id: string;
    name?: string;
    className?: string;
    type: string;
    placeholder?: string;
    notAutoComplete?: boolean;
    disabled?: boolean;
    autoFocus?: boolean;
    value?: string | any;
    refInput?: React.RefObject<HTMLInputElement>;
    InputLink?: boolean;
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    onKeyUp?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
}

const Input: React.FC<iInput> = (props) => {
    const { id, className, type, placeholder, value, name, notAutoComplete, disabled, autoFocus, refInput, onChange, onKeyUp, InputLink} = props
    
    return (
        <S.Input
            id={id}
            name={name}
            type={type}
            className={className}
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            onKeyUp={onKeyUp}
            autoComplete={notAutoComplete ? 'off' : ''}
            disabled={disabled}
            autoFocus={autoFocus}
            ref={refInput}
            InputLink={InputLink}
        >
        </S.Input>
    )

}

export default Input